import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './index.css';
import App from './App';
import MbplcApp from './MbplcApp'; // Import the MbplcApp component
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/" element={<App />} />          {/* Root URL shows App */}
        <Route path="/mbplc" element={<MbplcApp />} /> {/* /mbplc shows MbplcApp */}
      </Routes>
    </Router>
  </React.StrictMode>
);

reportWebVitals();
